export const LINE_ITEM_QUANTITY_LIMIT = 999999;
